import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { Publicacion } from '@app/shared';
import { Boletines } from '../../../../shared/models/publicacion.model';

@Injectable()
export class BulletinsDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  getMonths() {
    return [
      {
        value: 1,
        key: 'Enero'
      }, {
        value: 2,
        key: 'Febrero'
      }, {
        value: 3,
        key: 'Marzo'
      }, {
        value: 4,
        key: 'Abril'
      }, {
        value: 5,
        key: 'Mayo'
      }, {
        value: 6,
        key: 'Junio'
      }, {
        value: 7,
        key: 'Julio'
      }, {
        value: 8,
        key: 'Agosto'
      }, {
        value: 9,
        key: 'Septiembre'
      }, {
        value: 10,
        key: 'Octubre'
      }, {
        value: 11,
        key: 'Noviembre'
      }, {
        value: 12,
        key: 'Diciembre'
      }];
  }


  /**
   * Metodo que permite agregar un boletin.
   *
   * @param {number} id
   * @param {Boletines} bulletin
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  cretateBulletin(bulletin: Boletines): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminBulletin'), bulletin).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Boletín creado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error) {
              this.toastr.warning('Error al ejecutar operacion', err.error);
            } else if (err.error.detail) {
              this.toastr.warning('Error al ejecutar operacion', err.error.detail);
            }
            
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }



  /**
   * Metodo que permite modificar un boletin
   *
   * @param {number} id
   * @param {Boletines} bulletin
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  updateBulletin(id: number, bulletin: Boletines): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminBulletin', [id]), bulletin).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Boletín modificado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            this.toastr.warning('Error al ejecutar operacion', err.error.detail);
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  

  /**
   * Metodo que permite eliminar un un boletin
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  deleteBeulletin(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminBulletin', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Boletín eliminado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error) {
              this.toastr.warning('Error al ejecutar operacion', err.error);
            } else if (err.error.detail) {
              this.toastr.warning('Error al ejecutar operacion', err.error.detail);
            }
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/bulletins/shared/bulletins.data.service.ts